import {deferComponent} from '../Deferred/deferComponent';

// Shared by the result list and map; neither should pull the calendar into search.
export default deferComponent(() => import('./reservedTable'), 400);
